import 'reflect-metadata'

import '@/register-component-hooks'
import '@/register-service-worker'

import Vue from 'vue'

import App from '@/App'
import Sidebar from '@/app/sidebar/Sidebar'

import '../node_modules/fomantic-ui-css/semantic.min.css'
import '../node_modules/fomantic-ui-css/semantic.min.js'
import '@/styles/fonts/flaticon.css'
import '@/styles/style.css'

import SemanticUI from './components/semantic-ui'

import { fs } from '@/datastore'
import router from '@/routes'
import store from '@/store'

import auth from '@/store/modules/auth'
import grocery from '@/store/modules/grocery'

Vue.use(SemanticUI)

fs.enablePersistence({ synchronizeTabs: true })
	.then(() => auth.initialize())
	.then(() => {

		new Vue({
			render: h => h(Sidebar),
			router,
			store,
		}).$mount('#sidebar')

		new Vue({
			data: () => ({ loading: true }),
			async mounted() {
				await grocery.initialize()
				this.loading = false
			},
			render(h) {
				return h(App, {
					props: {
						loading: this.loading,
					},
				})
			},
			router,
			store,
		}).$mount('#content')

	})
